import { COOKIE_KEYS } from './cookie-utils';

export const schemeConfig = {
  defaultMode: 'light',
  modeStorageKey: COOKIE_KEYS.THEME_MODE,
  colorStorageKey: COOKIE_KEYS.THEME_COLOR
};

// Script to be included in the HTML head to prevent theme flashing
export function createColorSchemeScript() {
  return `
    (function() {
      try {
        // Function to get cookie value
        function getCookie(name) {
          const nameEQ = name + "=";
          const ca = document.cookie.split(';');
          for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
          }
          return null;
        }

        // Get color mode from cookie or default to light
        const colorMode = getCookie('${COOKIE_KEYS.THEME_MODE}') || 'light';
        
        // Apply color mode to document
        document.documentElement.setAttribute('data-theme', colorMode);
        
        // Additionally, apply MUI's class for compatibility
        if (colorMode === 'dark') {
          document.documentElement.classList.add('css-dark');
        }
      } catch (error) {
        console.error('Error applying theme:', error);
      }
    })();
  `;
}

// Function to inject color scheme script into head
export function injectColorSchemeScript() {
  if (typeof document !== 'undefined') {
    const script = document.createElement('script');
    script.innerHTML = createColorSchemeScript();
    document.head.appendChild(script);
  }
}

export default { schemeConfig, createColorSchemeScript, injectColorSchemeScript };